import React from 'react';

export default function TSpan({...rest }) {
  return <tspan {...rest} />;
}
